const Edit = ({ className, style }) => {
  return <span className={`icon-Edit ${className}`} style={style}></span>;
};

export default Edit;
